import React from 'react';

import { twMerge } from 'tailwind-merge';

import Dialog from 'components/dialog/dialog';

import Typography from 'components/typography/typography';

import Icon from 'components/icon/icon';

import Divider from 'components/divider/divider';

import Button from 'components/button/button';

interface HeaderDialogProps {
  isOpen?: boolean;
  onCloseClicked: () => void;
  children?: React.ReactNode;
  title?: string;
  buttonProps: {
    label: string;
    variant: 'primary' | 'outlined' | 'danger';
    onClick?: () => void;
  };
  footerClassName?: string;
  className?: string;
}
const HeaderDialog: React.FC<HeaderDialogProps> = (props) => {
  const {
    isOpen,
    onCloseClicked,
    title,
    buttonProps,
    children,
    className,
    footerClassName,
  } = props;

  const headerClassNames = twMerge(
    'relative flex flex-row justify-between',
    'md:justify-center items-center w-full px-2 py-4 md:px-4',
  );

  const bodyClassNames = twMerge('p-4 max-h-[500px] overflow-y-scroll');

  const footerClassNames = twMerge('flex w-full p-4', footerClassName);

  const closeButtonClassNames = twMerge(
    'absolute right-4 p-2 rounded-md',
    'hover:bg-gray100',
    'transition ease-in-out duration-300',
  );

  return (
    <Dialog
      isOpen={isOpen}
      onClose={buttonProps.onClick ?? onCloseClicked}
      className={className}
    >
      <div id="header" className={headerClassNames}>
        <Typography
          variant="title"
          as="p"
          className="text-gray800 max-w-[85%] text-center ml-3"
        >
          {title}
        </Typography>
        <button
          type="button"
          className={closeButtonClassNames}
          onClick={onCloseClicked}
        >
          <Icon icon="close" />
        </button>
      </div>
      <Divider orientation="horizontal" className="w-full" />
      <div className={bodyClassNames}>{children}</div>
      <Divider orientation="horizontal" className="w-full" />
      <div id="footer" className={footerClassNames}>
        <Button className="text-gray500 " {...buttonProps} />
      </div>
    </Dialog>
  );
};

export default HeaderDialog;
